export default "__VITE_ASSET__YTJEYGQ9__"